export class SuperavitModel {

    constructor(
        public cdCentrus?: string,
        public cdCentrusTit?: string,
        public dtReferencia?: string,
        public tpOcorrencia?: string,
        public dsOcorrencia?: string,
        public nrParcela?: string,
        public cdGrupo?: string,
        public vlOcor?: string,
        public vlSaldo?: string,
        public noPessoa?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/superavit.model.ts